import React from 'react'

import Jumbotron from '../components/Jumbotron/Jumbotron'
import ContentContainer from '../components/ContentContainer/ContentContainer'
import Button from '../components/Button/Button'
import FlexBox, { Justification } from '../components/FlexBox/FlexBox'
import TitledContent from '../components/TitledContent/TitledContent'
import FullWidthSection, { PaddingOption } from '../components/FullWidthSection/FullWidthSection'
import Paragraph from '../components/Paragraph/Paragraph'
import MainLayout from '../layouts/MainLayout'
import { COMPANY_NAME } from '../constants'

import genioLogo from './About/images/genio.svg'

import './About/about.scss'

const About: React.SFC = () => (
  <MainLayout title={COMPANY_NAME}>
    <Jumbotron title="Our Company is now called Genio" image={genioLogo}>
      <Paragraph>We're still the same people, we're just going by the name Genio now.</Paragraph>
      <div className="app__jumbotron-buttons">
        <Button to="https://genio.co/our-company/about-us/" className="app__jumbotron-button" primary forGlean>
          Learn more about us
        </Button>
      </div>
    </Jumbotron>

    <FullWidthSection paddingTop={PaddingOption.TINY} paddingBottom={PaddingOption.NONE}>
      <ContentContainer>
        <TitledContent title="Becoming Genio" center>
          <Paragraph>
            We have changed our name to Genio. We are expanding our impact to unlock better learning for everyone. We're the same people with the same purpose, just with a new name.
          </Paragraph>
          <FlexBox justify={Justification.CENTER} vertical className="about__pills-flexbox">
            <Button to="https://genio.co/blog/goodbye-glean-hello-genio" className="app__pill" forGlean>
              Why we changed our name
            </Button>
            <Button to="https://genio.co/our-company/our-story/" className="app__pill" forGlean>
              Our story
            </Button>
          </FlexBox>
        </TitledContent>
      </ContentContainer>
    </FullWidthSection>

    <FullWidthSection paddingTop={PaddingOption.TINY} paddingBottom={PaddingOption.NONE}>
      <ContentContainer>
        <TitledContent title="What this means for Sonocent Audio Notetaker customers" center>
          <Paragraph>
            We'll continue to support Audio Notetaker until August 2027, so there's no need to worry. However, we do recommend
            that customers transition to Genio Notes over the next few years. To learn more, read through our FAQs below.
          </Paragraph>
          <FlexBox justify={Justification.CENTER} vertical className="about__pills-flexbox">
            <Button to="https://help.genio.co/article/335-the-future-of-sonocent-audio-notetaker" className="app__pill" forGlean>
              Customer FAQs
            </Button>
            <Button to="https://genio.co/contact/" className="app__pill" forGlean>
              Contact us
            </Button>
          </FlexBox>
        </TitledContent>
      </ContentContainer>
    </FullWidthSection>

    <FullWidthSection paddingTop={PaddingOption.TINY} paddingBottom={PaddingOption.NONE}>
      <ContentContainer>
        <TitledContent title="The Genio Team is growing!" center>
          <Paragraph>
            We're always looking for talented new colleagues to join the Genio Team! To learn more about us and the
            roles available, visit our careers site.
          </Paragraph>
          <FlexBox justify={Justification.CENTER} className="about__pills-flexbox">
            <Button to="https://genio.co/our-company/careers" className="app__pill" forGlean>
              Careers at Genio
            </Button>
          </FlexBox>
        </TitledContent>
      </ContentContainer>
    </FullWidthSection>

    <FullWidthSection paddingTop={PaddingOption.TINY} paddingBottom={PaddingOption.NONE}>
      <ContentContainer>
        <TitledContent title="Contact us" center>
          <Paragraph>You can contact us via our new company website.</Paragraph>
          <FlexBox justify={Justification.CENTER} className="about__pills-flexbox">
            <Button to="https://genio.co/contact/" className="app__pill" forGlean>
              Contact us
            </Button>
          </FlexBox>
        </TitledContent>
      </ContentContainer>
    </FullWidthSection>
  </MainLayout>
)

export default About
